/** Always returns an array — handles undefined, null, objects, strings, numbers */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function safeArray<T = any>(val: T[] | null | undefined | unknown): T[] {
  return Array.isArray(val) ? (val as T[]) : [];
}
